<template>
  <b-container fluid>
    <b-row>
      <b-col>

        <b-card :title="$t('SETTINGS')" class="mb-2">

          <b-form v-on:submit.prevent="onSubmit" :if="details && details!==null" >
            <b-form-group id="input-group-1" label="Username:" label-for="input-1">
              <b-form-input disabled id="input-1" v-model="details.username" type="text" required placeholder="Enter email"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-2" label="Name:" label-for="input-2">
              <b-form-input disabled id="input-2" v-model="details.name" required placeholder="Enter name"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-3" label="Locale:" label-for="input-3">
              <b-form-select id="input-3" v-model="details.locale" :options="details.availableLocales" required></b-form-select>
            </b-form-group>

            <b-form-group id="input-group-password" label="Password:" label-for="input-2">
              <b-form-input id="user-password" v-model="password" type="password" placeholder="Enter password"></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-password-repeat" label="Repeat password:" label-for="input-2">
              <b-form-input id="user-repeat-password" v-model="repeatPassword" type="password" placeholder="Enter password" :state="passwordValidation"></b-form-input>
              <b-form-invalid-feedback :state="passwordValidation">Passwords mismatch</b-form-invalid-feedback>
            </b-form-group>

            <b-alert v-if="updateStatus===0" variant="success" show>Update ok!</b-alert>
            <b-alert v-else-if="updateStatus===1" show>{{'PASSWORD_RULES' | i18n }}</b-alert>

            <b-button :disabled="!passwordValidation" type="submit" variant="primary">Update</b-button>
          </b-form>
        </b-card>


      </b-col>
    </b-row>

  </b-container>
</template>

<script>
  import {mapGetters, mapState} from "vuex";

  export default {
    name: 'SettingsComponent',

    components: {},

    data() {
      return {
        password: "",
        repeatPassword: "",
        // locales: ['de_DE', 'en_UK'],
        show: true
      }
    },

    props: {
      details: Object,
      updateStatus: Number
    },

    computed: {
      ...mapState(['activeSurvey', 'absoluteDrillPath']),
      ...mapGetters(['realmName', 'studyName', 'authToken', 'pageByName', 'completePath']),

      passwordValidation() {
        return this.repeatPassword===this.password
      }

    },

    methods: {
      onSubmit() {
        this.$emit('update', { locale: this.details.locale, password: this.repeatPassword } )
      },

    },

  }
</script>